import { useI18n } from 'contexts/i18n';
import { DiscountRibbonProps, Styled } from '.';
import {
  getSubscriptionProduct,
  hasDiscountBySku,
  isSubscriableProduct,
  maxDiscount,
} from 'components/ProductTile/ProductTile.helper';
import { filterCouponsBySku } from 'components/ProductTile/ProductTile.helper';
import { filterDsoBulkDiscountBySku } from 'components/DSO/DSOProductDetails/DSOProductDetails.helper';
import { useSubscriptionProduct } from 'reactQuery/queries/subscriptions/useSubscriptionProducts';
import { isZeroCurrency } from 'utils';
import { MaterialTypeEnum } from 'types';

const DiscountRibbon = ({
  product,
  doctorPromotionList,
  dsoPromotionList,
  isDso,
}: DiscountRibbonProps) => {
  const i18n = useI18n();
  const { data: subscriptionProductList } = useSubscriptionProduct({
    enabled: !isDso,
  });

  const isDownloadable =
    product.materialType === MaterialTypeEnum.digital_physical ||
    product.materialType === MaterialTypeEnum.digital;

  if (isZeroCurrency(product.displayPrice) || isDownloadable) return null;

  if (dsoPromotionList) {
    const hasDsoDiscount = filterDsoBulkDiscountBySku(
      product,
      dsoPromotionList
    );
    if (hasDsoDiscount) {
      return <Styled.DiscountRibbon>{i18n['Discount']}</Styled.DiscountRibbon>;
    }
    return null;
  }

  const isDiscounted = hasDiscountBySku(product.sku, doctorPromotionList);
  const coupon = filterCouponsBySku(product.sku, doctorPromotionList);
  const isSubscribeable = isSubscriableProduct(
    subscriptionProductList,
    product.sku
  );
  const productList = getSubscriptionProduct(
    subscriptionProductList,
    product.sku
  );
  const discount = maxDiscount(productList);

  return (
    <>
      {isSubscribeable && !isDiscounted && (
        <Styled.DiscountRibbon>
          {i18n['Save up to']} {discount}%
        </Styled.DiscountRibbon>
      )}

      {isDiscounted && (
        <Styled.DiscountRibbon>
          {coupon?.highlighterText
            ? `${coupon?.highlighterText}`
            : i18n['Discount']}
        </Styled.DiscountRibbon>
      )}
    </>
  );
};

export default DiscountRibbon;
